import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IRequestState } from './interfaces';
import { IGetTargetDatabaseInstancesResponse } from '@/api/client';

import Api from '../api/helpers';

export interface IUserState {
  targetDatabases: { targetDatabases: string[] } & IRequestState;
}

const initialState: IUserState = {
  targetDatabases: {
    targetDatabases: [],
    isRequestActive: false,
    errorDetails: { statusCode: null, userMessage: null },
  },
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTargetDatabases.pending, (state) => {
      state.targetDatabases.isRequestActive = true;
    });
    builder.addCase(fetchTargetDatabases.fulfilled, (state, action) => {
      state.targetDatabases.isRequestActive = false;
      state.targetDatabases.targetDatabases = action.payload.databaseInstances;
    });
  },
});

export const fetchTargetDatabases = createAsyncThunk<IGetTargetDatabaseInstancesResponse, undefined>(
  'user/getTargetDatabaseInstances',
  async (_, thunkApi) => {
    const client = Api.getUserClient(thunkApi.dispatch);
    const response = await client.getTargetDatabaseInstances();
    return response;
  },
);

export default usersSlice.reducer;
